import React from 'react'
import Typography from '@components/typography'
import { Form, Formik } from 'formik'
import Column from '@components/column'
import Fields from '@components/fields'
import Button from '@components/button'
import Row from '@components/row'
import theme from '@utils/theme'
import { Booking, Transaction } from '@apis'
import { useModal } from '@context/ModalContext'
import { useNavigate } from 'react-router-dom'

const CancellationStatusUpdateModal = ({
  variant,
  item,
}: {
  variant?: string
  item?: any
}) => {
  const navigate = useNavigate()
  const [initialValue, setInitialValue] = React.useState({
    number: item.infos.esewaNo,
    amount: Number(item.totalAmount) - Number(item.infos.cancellationCharge),
    reason: item.infos.reason,
    receipt: '',
  })
  const { showModal, hideModal } = useModal()
  const handleRefundNow = async (values) => {
    const payload = {
      transactionStatus: 'Refund',
      receipt: {
        base64: values.receipt.base64,
        extension: values.receipt.extension,
      },
    }
    await Booking.update({
      state: 'bookings',
      id: item.id,
      data: payload,
    }).then(() => {
      hideModal()
      window.location.reload()
    })
  }
  return (
    <>
      <Typography color={'primary'} align={'center'} size={20}>
        Cancellation Request
      </Typography>
      <Formik initialValues={initialValue} onSubmit={handleRefundNow}>
        <Form>
          <Column>
            <Fields.Input
              name={'number'}
              label={'Esewa Number'}
              disabled={true}
            />
            <Fields.Input
              name={'amount'}
              label={'Refund Amount'}
              disabled={true}
            />
            <Fields.Input
              name={'reason'}
              label={'Cancellation Reason'}
              disabled={true}
            />
            <Fields.Upload name={'receipt'} label={'Upload Receipt'} />
          </Column>
          <br />
          <Row styleRow="justify-content:center">
            {(variant === 'both' || variant === 'reject') && (
              <Button
                title="Provide Refund Later"
                type="submit"
                styleButton={`color:${theme.colors.red};background:transparent;border:1px solid ${theme.colors.red}`}
                onClick={async () => {
                  await Booking.update({
                    state: 'bookings',
                    id: item.id,
                    data: { transactionStatus: 'Pending Refund' },
                  }).then(() => {
                    hideModal()
                    navigate('/admin/bookings?tab=Pending%20Refund')
                  })
                  hideModal()
                }}
              />
            )}

            {(variant === 'both' || variant === 'accept') && (
              <Button title="Provide Refund Now" type="submit" />
            )}
          </Row>
        </Form>
      </Formik>
    </>
  )
}

export default CancellationStatusUpdateModal
